import { UserOutlined } from '@ant-design/icons';
import { Avatar, AvatarProps } from 'antd';

export default function ProfilePicture({ children, icon, src, style = {}, ...rest }: AvatarProps) {
    return (
        <Avatar
            icon={src ? undefined : icon || <UserOutlined />}
            src={src}
            style={{ display: 'flex', justifyContent: 'center', ...style }}
            {...rest}
        >
            {children}
        </Avatar>
    );
}
